<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MN2zhF/tc-custom/9781418585884.jpg?1708485485778" alt="This image is the cover for the book Beautiful Mess"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beautiful Mess
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Can a band comprised of six very talented but very different musicians make a difference with their music?</b></p><p>What made it possible for Diamond Rio to weather the storms inherent in the fickle world of fame and fortune and go more than two decades without a single lineup change? Any reader in search of transparency and a behind-the-scenes look into the life of the band as a unit as well as the individual lives of the players and singers will be well satisfied. Can true loyalty exist within the competitive, seemingly unforgiving music industry? In <i>Beautiful Mess </i>Marty Roe, Dan Truman, Jimmy Olander, Brian Prout, Gene Johnson, and Dana Williams each has an entire chapter devoted to his personal and professional life. The book’s tone is a welcome rarity—not written from one player’s perspective, but from all six as they “meet in the middle.” <i>Beautiful Mess </i>is a wild ride from the edge of disaster and a little-known secret to an ongoing heart-warming revival.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Diamond Rio
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?30dc1a2f